import { render, staticRenderFns } from "./purchaseDetail.vue?vue&type=template&id=ea2355d8&scoped=true"
import script from "./purchaseDetail.vue?vue&type=script&lang=js"
export * from "./purchaseDetail.vue?vue&type=script&lang=js"
import style0 from "./purchaseDetail.vue?vue&type=style&index=0&id=ea2355d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2355d8",
  null
  
)

export default component.exports